import React from 'react';
import { AlertTriangle } from 'lucide-react';
export interface ClaimMonitorRow {
  ownerId: string;
  ownerName: string;
  activeClaims: number;
  expiringSoon: number;
  loansCreated: number;
  returned: number;
}

/**
 * Admin-only roll-up of real-time lead claims by loan officer, so managers can
 * see who is holding leads and who is converting them.
 */
export function ClaimMonitorTable({
  rows
}: {
  rows: ClaimMonitorRow[];
}) {
  if (rows.length === 0) {
    return <div className="bg-white rounded-xl border border-dashed border-slate-300 py-12 text-center" data-id="element-12" data-mp="1opyrsrg9is77">
        <p className="text-slate-500" data-id="element-13" data-mp="23n7xkq6bbyig">
          No claim activity yet across the team.
        </p>
      </div>;
  }
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-14" data-mp="1ynvb46jcstge">
      <div className="overflow-x-auto" data-id="element-15" data-mp="3f1v6r5b61wxu">
        <table className="w-full" data-id="element-16" data-mp="3f0jusi7khivn">
          <thead className="bg-slate-50 border-b border-slate-200" data-id="element-17" data-mp="3a3a5r3o3b98c">
            <tr className="text-left" data-id="element-18" data-mp="3a30e7bnecu0j">
              <th className="py-3 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-19" data-mp="xvizka66j3oi">
                Loan Officer
              </th>
              <th className="py-3 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-20" data-mp="12sixfxsvl04j">
                Active Claims
              </th>
              <th className="py-3 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-21" data-mp="1bvk1zu23ej63">
                Expiring Soon
              </th>
              <th className="py-3 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-22" data-mp="f6m6uaqfkj8e">
                Loans Created
              </th>
              <th className="py-3 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-23" data-mp="o57mny4ipk5h">
                Returned to Queue
              </th>
              <th className="py-3 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-24" data-mp="syajcf4ld9pw">
                Conversion
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-25" data-mp="e27ll6eivw8">
            {rows.map(row => {
            const worked = row.loansCreated + row.activeClaims + row.returned;
            const rate = worked > 0 ? Math.round(row.loansCreated / worked * 100) : 0;
            return <tr key={row.ownerId} className="hover:bg-slate-50/60" data-id="element-26" data-mp="18hrawdmob6a3">
                  <td className="py-4 px-6" data-id="element-27" data-mp="18jlvtrxy2ye6">
                    <div className="flex items-center gap-3" data-id="element-28" data-mp="kr52umco5m03">
                      <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-sm font-semibold text-slate-700 uppercase" data-id="element-29" data-mp="ktrkjet9xhw1">
                        {row.ownerName.substring(0, 2)}
                      </div>
                      <span className="font-medium text-slate-900" data-id="element-30" data-mp="pqrqlpq4ikn5">
                        {row.ownerName}
                      </span>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-sm font-medium text-slate-900" data-id="element-31" data-mp="216gc0cnqbblu">
                    {row.activeClaims}
                  </td>
                  <td className="py-4 px-6" data-id="element-32" data-mp="28o4inszrol1y">
                    {row.expiringSoon > 0 ? <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-700" data-id="element-33" data-mp="2dpk3bjy18pjt">
                        <AlertTriangle size={12} data-id="element-34" data-mp="23pt97jddwck9" /> {row.expiringSoon}
                      </span> : <span className="text-sm text-slate-400" data-id="element-35" data-mp="2rhi9blwg65br">—</span>}
                  </td>
                  <td className="py-4 px-6 text-sm font-medium text-emerald-700" data-id="element-36" data-mp="2weic9ny02ryn">
                    {row.loansCreated}
                  </td>
                  <td className="py-4 px-6 text-sm text-slate-600" data-id="element-37" data-mp="2mp73k2f0zpba">
                    {row.returned > 0 ? row.returned : '—'}
                  </td>
                  <td className="py-4 px-6" data-id="element-38" data-mp="3adqeyqtdgi7l">
                    <div className="flex items-center gap-2" data-id="element-39" data-mp="3f5hy4ga77lnp">
                      <div className="h-1.5 w-16 rounded-full bg-slate-100 overflow-hidden" data-id="element-40" data-mp="3f7umpcagou9q">
                        <div className="h-full rounded-full bg-emerald-500" style={{
                      width: `${rate}%`
                    }} data-id="element-41" data-mp="1rirgbzvh524k" />
                      </div>
                      <span className="text-sm text-slate-600 tabular-nums" data-id="element-42" data-mp="1hld286x0wpff">
                        {rate}%
                      </span>
                    </div>
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
}